<template>
  <div>
    <Modal v-model="visible" title="添加费用项" width="900" class="my-modal top" :mask-closable="false" :footer-hide="true">
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="selectItem"> </Table>
      </div>

      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    pageData:null,
    rankId:null,
  },
  data() {
    return {
      visible: false,
      listLoading: false,
      baseInfo:{},
      hasList: [], //已添加的列表
      selectIds:[],//选择的id
      tableData: [],
      columns: [
        {
          type: 'selection',
          width: 50,
          align: 'center'
        },
        {
          title: '费用项名称',
          key: 'name',
          minWidth: 140,
          tooltip: true,
          align: 'center'
        },
        {
          title: '费用项计算公式',
          key: 'ruleName',
          tooltip: true,
          minWidth: 300,
          align: 'center'
        }
      ]
    };
  },
  methods: {
    open(baseInfo, list) {
      this.baseInfo = baseInfo;
      this.hasList = list;
      this.visible = true;
      this.getList();
    },
    // 获取费用项列表
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/baseCommission/rankCommissions',
        type: 'GET',
        data: {
          rankId:this.rankId,
          type:1
        }
      })
        .then(res => {
          const idArr = this.hasList.map(item=>item.id);
          this.tableData = res.data[0].list.map(item=>{
            if(idArr.includes(item.id)){
              item._checked = true;
            }
            return item
          });
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    // 选择某项
    selectItem(selectArr) {
      console.log('selectItem', this.selectArr)
      this.selectIds = selectArr.map(item=>item.id);
    },
    // 
    save() {
      const params = {
        id:this.pageData.id,
        selected:this.selectIds,
        baseId:this.baseInfo.id,
        rankId:this.rankId,
      }
      if(this.listLoading) {
        return;
      }
      this.listLoading = true;
      this.$http({
        url: this.pageData.id?'/buz/baseCommissionJoin/edit':'/buz/baseCommissionJoin/add',
        type: 'POST',
        data: params
      }).then(res=>{
        this.$notice.success('新增成功');
        this.$emit('reload')
        this.visible = false;
      }).finally(()=>{
        this.listLoading = false;
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.table-box {
  margin-top: 20px;
}
</style>
